import React from 'react';
import { HelpCircle, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import IndividualWellness from '../components/IndividualWellness';
import Contact from '../components/Contact';

const IndividualWellnessPage = () => {
  const whatsappNumber = "+919088771406";

  const faqs = [
    {
      q: "Which package is right for me?",
      a: "If you are new to energy healing or seeking quick relief from acute stress, Package 1 is perfect. If you are dealing with chronic stress, emotional fatigue, or long-standing energetic blockages, Package 2 (4 Weeks) or Package 3 (3-6 Months) provides structured transformation."
    },
    {
      q: "Can I customize a package according to my needs?",
      a: "Yes! All individual packages can be adapted following your initial energy diagnostic session with Founder & Healer Preeti Biswas."
    },
    {
      q: "How do WhatsApp bookings work?",
      a: "Clicking any 'Book Consultation via WhatsApp' button automatically opens WhatsApp with a pre-filled message specifying your chosen package. You can send it directly to connect with us immediately."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Main Packages Content */}
      <IndividualWellness />

      {/* FAQs Section */}
      <section className="bg-white border-t border-lotus-petal px-6 py-16 lg:px-8 lg:py-24">
        <div className="mx-auto max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7 }}
            className="text-center mb-12"
          >
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-lotus-deep block mb-2">
              Frequently Asked Questions
            </span>
            <h3 className="font-serif text-3xl text-lotus-ink">
              Choosing Your Healing Journey
            </h3>
          </motion.div>

          <div className="space-y-6">
            {faqs.map((faq, idx) => (
              <motion.div 
                key={idx} 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                whileHover={{ y: -2 }}
                className="rounded-2xl bg-background p-6 border border-lotus-petal/70 transition-all duration-300 hover:shadow-md hover:border-lotus-deep/40"
              >
                <h4 className="flex items-center gap-2.5 font-serif text-xl font-medium text-lotus-ink mb-3">
                  <HelpCircle size={20} className="text-lotus-deep shrink-0" />
                  {faq.q}
                </h4>
                <p className="text-sm sm:text-base text-lotus-ink/75 leading-relaxed pl-8">
                  {faq.a}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Quick Help Card */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-12 rounded-3xl bg-lotus-petal/30 p-8 text-center border border-lotus-petal shadow-sm"
          >
            <h4 className="font-serif text-2xl text-lotus-ink mb-2">Still Unsure Which Package Fits You?</h4>
            <p className="text-sm text-lotus-ink/70 max-w-xl mx-auto mb-6">
              Chat directly with our healer on WhatsApp to discuss your symptoms and get a personalized recommendation.
            </p>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href={`https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent("Hi Lotus Prana, I need help deciding which Individual Wellness Package is best for me.")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-lotus-deep px-6 py-3 text-xs font-semibold uppercase tracking-wider text-white hover:bg-lotus-deep/90 transition-all shadow-md active:scale-95"
            >
              <MessageCircle size={16} />
              <span>Ask Healer on WhatsApp</span>
            </motion.a>
          </motion.div>
        </div>
      </section>

      {/* Footer Contact */}
      <Contact />
    </div>
  );
};

export default IndividualWellnessPage;
